import { render, staticRenderFns } from "./SendMails.yaml?vue&type=template&id=271e367d&component"
import script from "./SendMails.yaml?vue&type=script&lang=ts&component"
export * from "./SendMails.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports